import React from "react";

const PublishShiftAdvanceBadges = ({ label, className = "" }) => {
  if (!label) return null;

  return (
    <span
      className={`inline-flex rounded border px-1.5 py-0.5 text-[10px] font-semibold leading-tight ${className}`}
    >
      {label}
    </span>
  );
};

export default PublishShiftAdvanceBadges;
